<div class="bg-white rounded-xl w-full h-full p-4 relative overflow-hidden">
  <div class="lg:flex justify-center gap-8 h-full">
    <div class="lg:w-2/3 overflow-auto px-4 flex flex-col items-stretch">
      <xemex-general-info
        [isLoading]="isLoading"
        [userProfile]="userProfile"
        [userAvatar]="userAvatar"
        [isLoadingAvatar]="userStore.isLoadingAvatar()"
        (uploadAvatar)="onUploadAvatar($event)"
      />

      <div class="m-auto">
        <button
          class="inline-block m-auto"
          mat-flat-button
          color="primary"
          type="button"
          (click)="onSaveChanges()"
        >
          {{ 'general.btnSaveChanges' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
